// components/layouting/RightPanel/CurrentSheetsList.jsx
import React, { useEffect, useState } from "react";
import api from "../../../services/api";
import SheetPreview from "../../Common/SheetPreview"
import FileUploadModal from "../common/FileUploadModal";
import DownloadButton from "../../Common/DownloadButton";

export default function CurrentSheetsList({fetchOrderPositions}) {
  const [sheets, setSheets] = useState([]);
  const [selected, setSelected] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const statusLabels = {
      [-1]: "Ошибка",
      [0]: "Отменено",
      [1]: "Ожидание",
      [2]: "В процессе",
      [3]: "Завершено",
    };

  const fetchSheets = async () => {
    setLoading(true);
    try {
      const res = await api.get("/layouting/sheets");
      const newSheets = res.data.elements || [];
      
      // Используем текущее состояние sheets для сравнения
      setSheets(prevSheets => {
        trackCompletedSheets(prevSheets, newSheets);
        return newSheets;
      });
    } catch (err) {
      console.error("Ошибка загрузки листов:", err);
    }
    setLoading(false);
  };

  const trackCompletedSheets = (oldSheets, newSheets) => {
    try {
      // Находим ID завершённых листов в старом состоянии
      const oldCompletedIds = oldSheets
        .filter(sheet => sheet.status === 3)
        .map(sheet => sheet.id);
      
      // Находим ID завершённых листов в новом состоянии
      const newCompletedIds = newSheets
        .filter(sheet => sheet.status === 3)
        .map(sheet => sheet.id);
      
      // Находим новые завершённые листы (которых не было в старом состоянии)
      const newlyCompletedIds = newCompletedIds.filter(
        id => !oldCompletedIds.includes(id)
      );
      
      // Если есть новые завершённые листы, вызываем fetchOrderPositions
      if (newlyCompletedIds.length > 0) {
        console.log("Обнаружены новые завершённые листы:", newlyCompletedIds);
        fetchOrderPositions();
      }
    } catch (err) {
      console.error("Ошибка при отслеживании завершённых листов:", err);
    }
  };

  useEffect(() => {
    fetchSheets();
    const interval = setInterval(fetchSheets, 5000);
    return () => clearInterval(interval);
  }, []);

  const toggleSelect = (id) => {
    setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const toggleSelectAll = () => {
    if (selected.length === sheets.length) setSelected([]);
    else setSelected(sheets.map((x) => x.id));
  };

  const toggleExpand = (id) => setExpanded(expanded === id ? null : id);

  const moveToPrinting = async () => {
    if (selected.length === 0) return;
    await api.patch("/layouting/sheets/move-to-printing", { layoutingSheetsIds: selected });
    setSelected([]);
    fetchSheets();
    fetchOrderPositions();
  };

  const deleteSheet = async (id) => {
    if (!window.confirm("Удалить лист?")) return;
    await api.delete(`/layouting/sheets/${id}`);
    fetchSheets();
    fetchOrderPositions();
  };

  const abortSheet = async (id) => {
    if (!window.confirm("Вы уверены, что хотите отменить обработку?")) return;
    await api.post(`/layouting/sheets/abort/${id}`);
    fetchSheets();
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <div>
          <button className="btn btn-success" onClick={() => setIsUploadOpen(true)}>
            Загрузить лист
          </button>
        </div>

        <div>
          <button
            className="btn btn-warning me-2"
            disabled={selected.length === 0}
            onClick={moveToPrinting}
          >
            Передать на печать ({selected.length})
          </button>
        </div>
      </div>

      {/* Выбрать все */}
      {sheets.length > 0 && (
        <div className="d-flex align-items-center mb-2">
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={selected.length === sheets.length}
            ref={(el) => el && (el.indeterminate = selected.length > 0 && selected.length < sheets.length)}
            onChange={toggleSelectAll}
          />
          <span>Выбрано {selected.length} из {sheets.length}</span>
        </div>
      )}

      {sheets.map((s) => (
        <div key={s.id} className="border rounded p-2 mb-2">
          <div className="d-flex justify-content-between" style={{ cursor: "pointer" }} onClick={() => toggleExpand(s.id)}>
            <div className="d-flex">
              <input
                type="checkbox"
                className="form-check-input me-3"
                checked={selected.includes(s.id)}
                onClick={(e) => e.stopPropagation()}
                onChange={() => toggleSelect(s.id)}
              />
              <div>
                <div className="fw-bold">{s.name}</div>
                <small className="text-muted">{new Date(s.creationTime).toLocaleString()}</small>
              </div>
              <div>
                {s.cutMachineType == 2 && (
                  <span className="ms-2 badge bg-primary">Плоттер</span>
                )}
              </div>
            </div>

            <div className="col-md-3 col-6">
              <small className="text-muted d-block">Создатель:</small>
              <div>{s.createdBy}</div>
            </div>

            <div className="text-end">
              <p className="mb-0">
                <strong>Статус:</strong> {statusLabels[s.status]}
              </p>
            </div>
          </div>

          {expanded === s.id && (
            <div className="card-footer d-flex flex-column gap-2">
              {s.status == 3 && (
                  <div className="mt-2">
                    <SheetPreview jobId={s.jobId} width={600} height={400}/>
                  </div>
              )}

              {s.status == -1 && (
                <div className="text-danger">
                  {s.errorMessage}
                </div>
              )}
              
              <div className="d-flex flex-wrap gap-2">
                <DownloadButton
                  endpoint={`/layouting/sheets/download/${s.id}`}
                  buttonLabel="Скачать .cdr"
                  method="post"
                  defaultFileName="sheet.cdr"
                />
                
                {(s.status === -1 || s.status === 0 || s.status === 3) && (
                  <button
                    className="btn btn-outline-danger"
                    onClick={(e) => { e.stopPropagation(); deleteSheet(s.id); }}
                  >
                    Удалить
                  </button>
                )}
                {(s.status === 1 || s.status === 2) && (
                  <button className="btn btn-danger" onClick={() => abortSheet(s.id)}>
                    Отменить
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      ))}

      {/* Модалка загрузки нового листа */}
      <FileUploadModal
        show={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
        onUploaded={() => {
          setIsUploadOpen(false);
          fetchSheets();
        }}
      />
    </>
  );
}
